import { usePrevious } from "@react-hookz/web";
import { Input, Label } from "@rebass/forms";
import { debounce, filter } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { isChrome } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, Flex } from "rebass";
import { LoadingFrame } from "../components/common/LoadingFrame";
import { Price } from "../components/common/Price";
import SwitchSwap from "../components/common/SwitchSwap";
import { ToastMessage } from "../components/order/ToastMessage";
import { Product } from "../components/product";
import { ProductSwap } from "../components/product/ProductSwap";
import ChecvronDown from "../icons/ChevronDown";
import OrderStatusGreen from "../icons/OrderStatusGreen";
import OrderStatusRed from "../icons/OrderStatusRed";
import OrderStatusYellow from "../icons/OrderStatusYellow";
import { MainLayout } from "../layouts/MainLayout";
import {
  systemActions,
  yodaCatalogueActions,
  yodaCustomerActions,
  yodaIdentityActions,
  yodaOrdersActions,
  yodaMessageActions,
} from "../logic/actions";
import openIcon from "../static/images/icon-accordion-close-transparent.png";
import closeIcon from "../static/images/icon-accordion-open-transparent.png";
import { getLocalizedString, theme } from "../utils";
import config from "../utils/globalConfig";
import { selectTextColor } from "../utils/selectColorFunction";
import StatusViewMobile from "./StatusViewMobile";
import FilterItem from "../components/catalogue/FilterItem";
import OrderTabs from "../components/order/OrderTabs";
import Tooltip from "../components/common/Tooltip";
import FilterItemMobile from "../components/catalogue/FilterItemMobile";
import MobileProductDetail from "../components/product/MobileProductDetail";
import useResponsive from "../hooks/useResponsive";
import FiltersAndSearchMobile from "../components/common/FiltersAndSearchMobile";
import useFiltersAndSearchMobile from "../hooks/useFiltersAndSearchMobile";
import useGuardCustomerRoute from "../hooks/useGuardCustomerRoute";
import useCatalogueFilters from "../hooks/useCatalogueFilters";
import useOrderType from "../hooks/useOrderType";
import Chip from "../components/common/Chip";
import ConfigurationCheck from "../components/order/ConfigurationCheck";
import {
  Redirect,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import SearchInput from "../components/common/SearchInput";
import CatalogueNavigation from "../components/order/CatalogueNavigation";
import CatalogueCount from "../components/order/CatalogueCount";
import CannotOrderMessage from "../components/order/CannotOrderMessage";
import { getLocalizedText } from "../utils/getLocalizedText";
const CataloguePage = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const history = useHistory();

  const catalogueRefs = useRef({});

  const {
    calculateAllFilter,
    toggleFilterMobile,
    openFilterMobile,
    removeFilter,
    removeAllFilters,
    colorTextFilter,
    selectSizeFilter,
    selectColorFilter,
    selectCollectionFilter,
    selectContinuousFilter,
    selectCategoryFilter,
    selectProductTypeFilter,
    selectFittingFilter,
    colorFilterValues,
    sizeFilterValues,
    productTypeFilterValues,
    categoryFilterValues,
    collectionFilterValues,
    continuousFilterValues,
    fittingFilterValues,
    closureFilterValues,
    hoodFilterValues,
    paddingFilterValues,
    pocketsFilterValues,
    reversibleFilterValues,
    sleevesFilterValues,
    colorFilterFiltered,
    allFilterValue,
    searchText,
    setColorFilterFiltered,
    setSearchText,
    hasFilters,
    openFilters,
    toggleFilter,
    selectClosureFilter,
    selectHoodFilter,
    selectPaddingFilter,
    selectPocketsFilter,
    selectReversibleFilter,
    selectSleevesFilter,
  } = useCatalogueFilters();

  const {
    catalogue,
    totalCount,
    collectionFilterList,
    continuousFilterList,
    categoryFilterList,
    productTypeFilterList,
    colorFilterList,
    sizeFilterList,
    fittingFilterList,
    closureFilterList,
    hoodFilterList,
    paddingFilterList,
    pocketsFilterList,
    reversibleFilterList,
    sleevesFilterList,
  } = useSelector((state) => state.yodaCatalogue);

  const { offsetTop, minimizedUi, mobileMinicartOpen } = useSelector(
    (state) => state.system,
  );

  const { customer } = useSelector((state) => state.yodaCustomer);

  const { currentPage, totalPages, loadingNext } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { catalogueSelected, tab } = useSelector((state) => state.system);
  const { colors } = useSelector((state) => state.yodaIdentity);
  const {
    order,
    orderRowDetails,
    statusCode,
    error,
    totalReorder,
    totalSwap,
    maxSwap,
  } = useSelector((state) => state.yodaOrders);
  const { budget } = useSelector((state) => state.yodaBudget);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const { isMobile, breakpoint } = useResponsive();

  const filterProps = useFiltersAndSearchMobile();

  const [orderType, setOrderType] = useState(0);
  const [showStatusView, setShowStatusView] = useState(false);
  const [seasonCodeP, setSeasonCodeP] = useState(0);
  const [flagColor, setFlagColor] = useState("green");
  const [catalogueRequestNext, setCatalogueRequestNext] = useState(false);
  const [nextPageInLoading, setNextPageInLoading] = useState(false);
  const [switchOrderMessage, setSwitchOrderMessage] = useState(false);
  const [fistIngressCatalogue, setFistIngressCatalogue] = useState(true);

  const { isSwapEnabledForOrder } = useOrderType();

  const inputSearchRef = useRef();

  const disableScroll =
    !!mobileMinicartOpen || !!catalogueSelected || !!showStatusView;

  useGuardCustomerRoute({ matchOrder: true });

  useEffect(() => {
    return () => {
      dispatch(yodaOrdersActions.resetOldOrder());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      yodaMessageActions.getMessages(localStorage.getItem("selectedCustomer")),
    );

    return () => {
      dispatch(yodaMessageActions.clearMessages());
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(systemActions.closeCatalogueItem());
      dispatch(systemActions.setTab(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const type = orderType == config.ORDER_TYPE_SWAP ? 1 : 0;
    if (orderType && tab === null) dispatch(systemActions.setTab(type));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderType, tab]);

  useEffect(() => {
    if (colorFilterList?.length) setColorFilterFiltered(colorFilterList);
  }, [colorFilterList]);

  useEffect(() => {
    setFistIngressCatalogue(false);
  }, []);

  function handleKeyPress(event) {
    if (event.keyCode == 9) {
      event.preventDefault();
      let focusedPadIndex = -1;
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads?.length; ++index) {
        if (numericPads[index].style.display == "block") {
          focusedPadIndex = index;
        }
      }
      let i = (focusedPadIndex + 1) % numericPads?.length;
      if (numericPads[i] !== undefined) {
        numericPads[i].click();
      }
    }
    if (event.key == "Enter") {
      event.preventDefault();
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads?.length; ++index) {
        if (numericPads[index].style.display == "block") {
          numericPads[index].blur();
        }
      }
    }
    if (event.keyCode === 187) {
      event.preventDefault();
      let el = document.querySelector(".valueUp");
      if (el) {
        el.click();
      }
    }
    if (event.keyCode === 189) {
      event.preventDefault();
      let el = document.querySelector(".valueDown");
      if (el) {
        el.click();
      }
    }
  }

  const handleMobileDetailClose = (productId) => {
    setTimeout(() => {
      catalogueRefs?.current?.[productId]?.scrollIntoView?.({ block: "end" });
    });
  };

  const handleRemove = (value) => {
    removeFilter(value);
    if (inputSearchRef.current && value.startsWith("search_"))
      inputSearchRef.current.value = "";
  };

  const handleRemoveAll = () => {
    removeAllFilters();
    if (inputSearchRef.current) inputSearchRef.current.value = "";
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isWindowScrolledToBottom = useCallback(
    debounce((event, disableScroll) => {
      if (event.cancelable) event.preventDefault();
      if (document && window) {
        const scrollableHeight = Math.round(
          document.documentElement.scrollHeight - window.innerHeight,
        );
        const bottom =
          window.scrollY >= scrollableHeight - 1 &&
          window.scrollY <= scrollableHeight + 1;
        if (bottom && !disableScroll) {
          setCatalogueRequestNext(true);
        }
      }
    }, 600),
    [],
  );

  useEffect(() => {
    dispatch(yodaOrdersActions.orderReset(null));
    if (window) {
      window.addEventListener("keydown", handleKeyPress);
      window.addEventListener("switchOrderRequest", switchOrder);
    }
    if (document) {
      setTimeout(() => {
        document
          .getElementById("scrollContainer")
          ?.addEventListener?.("scroll", isInViewport);
      }, 1000);
      document.externalPinPadHandle = {};
    }
    return () => {
      if (window) {
        window.removeEventListener("keydown", handleKeyPress);
        window.removeEventListener("switchOrderRequest", switchOrder);
      }
      if (document) {
        const scroll = document.getElementById("scrollContainer");
        if (scroll) {
          scroll.removeEventListener("scroll", isInViewport);
        }
        document.externalPinPadHandle = undefined;
        document.orderTypeId = undefined;
        document.swapRowExist = undefined;
        document.orderRowDetails = undefined;
      }
    };
  }, []);

  useEffect(() => {
    if (document) {
      document.body.addEventListener("touchmove", (e) =>
        isWindowScrolledToBottom(e, disableScroll),
      );
    }
    return () => {
      if (document) {
        document.body.removeEventListener("touchmove", (e) =>
          isWindowScrolledToBottom(e, disableScroll),
        );
      }
    };
  }, [disableScroll, isWindowScrolledToBottom]);

  useEffect(() => {
    if (orderId) {
      dispatch(yodaOrdersActions.getOrderById(orderId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  useEffect(() => {
    if (order && tab !== null) {
      let seasonCode = order.seasonId;
      let lineCode = order?.customData?.lineId;

      if (document) {
        document.orderTypeId = order.orderTypeId;
      }
      setSeasonCodeP(seasonCode);

      if (!fistIngressCatalogue) {
        handleRemoveAll();
        dispatch(yodaCatalogueActions.clearOrderCatalog());
        if (tab === 0) {
          dispatch(
            yodaCatalogueActions.getAll({
              searchText,
              seasonId: seasonCode,
              lineId: lineCode,
              customerId: order.stakeholderId,
            }),
          );
        } else if (tab === 1) {
          dispatch(
            yodaCatalogueActions.getAllSwap({
              searchText,
              seasonId: seasonCode,
              lineId: lineCode,
              customerId: order.stakeholderId,
            }),
          );
        }
      }

      if (tab === 0) {
        dispatch(systemActions.expandCatalogueItem(0));
      } else if (tab === 1) {
        dispatch(systemActions.expandCatalogueItem(0));
      }
      dispatch(yodaCustomerActions.getOne(order.stakeholderId));
    }
  }, [fistIngressCatalogue, order, tab]);

  useEffect(() => {
    dispatch(yodaIdentityActions.getColors());
    dispatch(yodaOrdersActions.orderIdReset());
    dispatch(yodaOrdersActions.getOrderDetails(orderId));
    dispatch(
      yodaOrdersActions.getOrderConfiguration(
        localStorage.getItem("selectedCustomer"),
      ),
    );
  }, []);

  useEffect(() => {
    if (
      catalogueRequestNext &&
      currentPage + 1 <= totalPages &&
      !nextPageInLoading
    ) {
      let seasonCode = order?.seasonId;
      let lineCode = order?.customData?.lineId;

      if (tab == 0) {
        dispatch(
          yodaCatalogueActions.addAll({
            searchText,
            page: currentPage + 1,
            pageSize: config.PAGE_SIZE,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );
      } else if (tab == 1) {
        dispatch(
          yodaCatalogueActions.addAllSwap({
            searchText,
            page: currentPage + 1,
            pageSize: config.PAGE_SIZE,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );
      }
      setNextPageInLoading(true);
    }
  }, [catalogueRequestNext]);

  useEffect(() => {
    if (currentPage == 1) {
      setNextPageInLoading(false);
      setCatalogueRequestNext(false);
    }
  }, [currentPage]);

  useEffect(() => {
    setNextPageInLoading(false);
    setCatalogueRequestNext(false);
    document
      .getElementById("scrollContainer")
      ?.scrollTo({ top: 0, behavior: "smooth" });
  }, [tab]);

  useEffect(() => {
    if (!loadingNext && nextPageInLoading) {
      setNextPageInLoading(false);
      setCatalogueRequestNext(false);
    }
  }, [loadingNext]);

  const previousAllFilterValue = usePrevious(allFilterValue);
  useEffect(() => {
    const currSearch = allFilterValue?.find(
      (filter) => filter?.type === "search_",
    );
    const prevSearch = previousAllFilterValue?.find(
      (filter) => filter?.type === "search_",
    );
    if (
      (allFilterValue?.length !== previousAllFilterValue?.length ||
        currSearch?.text !== prevSearch?.text) &&
      order &&
      tab !== null
    ) {
      let seasonCode = order.seasonId;
      let lineCode = order.customData?.lineId;

      if (tab === 0) {
        dispatch(
          yodaCatalogueActions.getAll({
            searchText,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );

        dispatch(systemActions.expandCatalogueItem(0));
      } else if (tab == 1) {
        dispatch(
          yodaCatalogueActions.getAllSwap({
            searchText,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );

        dispatch(systemActions.expandCatalogueItem(0));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFilterValue, previousAllFilterValue]);

  function isInViewport() {
    if (!isMobile) {
      const rect = document
        .getElementById("checkForNext")
        ?.getBoundingClientRect();
      let check = false;
      if (rect) {
        check =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth);
      }

      setCatalogueRequestNext(!!check);
    }
  }

  function switchOrder(event) {
    if (
      document?.orderTypeId == config.ORDER_TYPE_SWAP &&
      document?.swapRowExist
    ) {
      setSwitchOrderMessage(getLocalizedString("SWITCH_ORDER"));
    } else {
      dispatch(yodaOrdersActions.switchOrder(orderId));
      if (document.orderTypeId == config.ORDER_TYPE_SWAP) {
        dispatch(systemActions.setTab(0));
      } else {
        dispatch(systemActions.setTab(1));
      }
    }
  }

  useEffect(() => {
    document.swapRowExist =
      filter(
        orderRowDetails,
        (k, v) => k.customData.typeId == config.ORDER_TYPE_SWAP,
      ).length > 0;
    document.orderRowDetails = { ...orderRowDetails };
  }, [orderRowDetails]);

  function selectTextFilter(event) {
    if (event.keyCode === 13) {
      if (inputSearchRef.current) inputSearchRef.current.value = "";
      changeQueryClick();
      filterProps.setOpenSearch(false);
      return;
    }
    let value = event.target.value;
    setSearchText(value);
  }

  function handlePasteSearch(event) {
    setSearchText(event.clipboardData.getData("Text"));
  }

  function sendBtn() {
    if (inputSearchRef.current) inputSearchRef.current.value = "";
    changeQueryClick();
    filterProps.setOpenSearch(false);
  }

  const resetScroll = () => {
    if (window) window.scrollTo(0, 0);
    const scrollContainer = document?.getElementById("scrollContainer");
    if (scrollContainer) scrollContainer.scrollTo(0, 0);
  };

  function changeQueryClick() {
    calculateAllFilter();
    resetScroll();
  }

  function reorderCatalogue(array) {
    let tmpArray = [];
    const gridColumnCount = breakpoint([2, 2, 3]);
    for (let i = 0; i < array?.length; i += gridColumnCount) {
      let tmpSubArray = [];
      let chunk = array.slice(i, i + gridColumnCount);

      let chuckExpanded = chunk.filter((e) => e.productId == catalogueSelected);
      let chuckNotExpanded = chunk.filter(
        (e) => e.productId != catalogueSelected,
      );

      tmpSubArray = [...chuckExpanded, ...chuckNotExpanded];
      if (chuckExpanded.length > 0) {
        tmpArray = [...tmpArray, tmpSubArray];
      } else {
        tmpArray = [...tmpArray, tmpSubArray];
      }
    }
    return tmpArray.flat();
  }

  useEffect(() => {
    let color = "";
    if (statusCode == 2) color = "green";
    if (statusCode == 1) color = "yellow";
    if (statusCode == 0) color = "red";
    setFlagColor(color);
  }, [statusCode]);

  useEffect(() => {
    if (order) {
      setOrderType(order.orderTypeId);
    }
  }, [order]);

  if (me?.error === "not-authorized") {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: true,
          },
        }}
      />
    );
  }
  return (
    <MainLayout>
      <LoadingFrame
        catalog
        order={!!catalogue && !!me && !!customer}
      ></LoadingFrame>
      <ToastMessage
        message={
          error &&
          error.message &&
          error.message.replaceAll(" , ", "\r\n").replaceAll(", ", "\r\n")
        }
        confirmFunction={() => {
          dispatch(yodaOrdersActions.resetError());
        }}
        style={{ width: 600 }}
      />
      <ConfigurationCheck
        message={<CannotOrderMessage />}
        buttonLabelCode="ORDER_PAGE_BACK_BUTTON"
        confirmFunction={() => {
          history.push("/orders/" + order?.stakeholderId);
        }}
      />
      <ToastMessage
        message={switchOrderMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(systemActions.setTab(0));
          dispatch(yodaOrdersActions.switchOrder(orderId));
          setSwitchOrderMessage(null);

          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setSwitchOrderMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600, fontSize: "0.8em" }}
      />
      <Box sx={{ width: "100%", position: ["unset", "relative"] }}>
        <Box
          display={["none", "none", "block"]}
          sx={{ position: "sticky", top: 0, zIndex: 2 }}
        >
          {/* DESKTOP TABS */}
          <OrderTabs
            pt={2}
            px={4}
            catalogueTab={tab}
            setCatalogueTab={(tab) => {
              dispatch(systemActions.setTab(tab));
            }}
          />
          {/* END - DESKTOP TABS */}
        </Box>
        {!minimizedUi && (
          <Box
            display={["block", "block", "none"]}
            sx={{
              position: "sticky",
              top: [offsetTop, 0],
              zIndex: [1, 2],
              background: "#fff",
              padding: "10px 0 0",
            }}
          >
            {/* MOBILE TABS */}
            <Flex
              sx={{
                flexDirection:
                  order?.orderTypeId === config.ORDER_TYPE_REORDER
                    ? "row"
                    : "column",
                width: "100vw",
              }}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Flex
                justifyContent="space-between"
                alignItems={"flex-start"}
                width={
                  order?.orderTypeId === config.ORDER_TYPE_REORDER
                    ? "auto"
                    : "100%"
                }
              >
                <Flex alignItems={"center"} sx={{ gap: "8px" }}>
                  <Box
                    bg={`${tab === 0 ? "#A2A2A2" : "white"}`}
                    p="4px 9px 4px 19px"
                    style={{
                      borderRadius: "0px 5px 5px 0px",
                      border: "1px solid #a2a2a2",
                    }}
                    onClick={() => {
                      if (tab === 1) {
                        dispatch(systemActions.setTab(0));
                      }
                    }}
                  >
                    <span
                      style={{
                        color: tab === 0 ? "white" : "black",
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      {getLocalizedString("REORDER")}
                    </span>
                  </Box>
                  {isSwapEnabledForOrder() && (
                    <SwitchSwap variant="contained" />
                  )}
                </Flex>
                <Flex
                  style={{ gap: "8px" }}
                  alignItems="center"
                  p={`0 ${
                    order?.orderTypeId === config.ORDER_TYPE_REORDER
                      ? "10px"
                      : "0"
                  } 0 0`}
                >
                  {showStatusView && (
                    <StatusViewMobile
                      onClose={() => setShowStatusView((s) => !s)}
                    />
                  )}
                  <Flex sx={{ flex: 1 }}>
                    {order?.orderTypeId !== config.ORDER_TYPE_REORDER && (
                      <Box
                        ml="8px"
                        p="4px 19px 4px 9px"
                        style={{
                          borderRadius: "5px 0px 0px 5px",
                          border: "1px solid #a2a2a2",
                          backgroundColor: tab === 1 ? "#a2a2a2" : null,
                        }}
                        onClick={() => {
                          if (tab === 0) {
                            dispatch(systemActions.setTab(1));
                          }
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "bold",
                            color: tab === 1 ? "white" : null,
                          }}
                        >
                          {getLocalizedString("SWAP_TAB")}
                        </span>
                      </Box>
                    )}
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                alignItems={"center"}
                sx={{
                  width:
                    order?.orderTypeId !== config.ORDER_TYPE_REORDER
                      ? "100%"
                      : "auto",
                  justifyContent: "flex-end",
                  gap: "10px",
                  px: "10px",
                  pt:
                    order?.orderTypeId !== config.ORDER_TYPE_REORDER
                      ? "10px"
                      : 0,
                }}
              >
                {showStatusView && (
                  <StatusViewMobile
                    onClose={() => setShowStatusView((s) => !s)}
                  />
                )}
                <Flex
                  onClick={() => setShowStatusView((s) => !s)}
                  alignItems={"center"}
                >
                  <Flex
                    sx={{
                      fontSize: "0.8em",
                      lineHeight: "0.8em",
                    }}
                  >
                    {getLocalizedString("Stato")}:
                  </Flex>
                  {flagColor === "green" && (
                    <OrderStatusGreen style={{ width: 14, height: 14 }} />
                  )}
                  {flagColor === "yellow" && (
                    <OrderStatusYellow style={{ width: 14, height: 14 }} />
                  )}
                  {flagColor === "red" && (
                    <OrderStatusRed style={{ width: 14, height: 14 }} />
                  )}
                </Flex>
                <Flex
                  alignItems={"center"}
                  sx={{
                    fontSize: "0.8em",
                    lineHeight: "0.8em",
                    gap: "2px",
                  }}
                >
                  {getLocalizedString(
                    orderType == config.ORDER_TYPE_REORDER
                      ? "TABMENU_MAX"
                      : "TABMENU_THRESHOLD",
                  )}
                  <Price
                    negativeAsColor={true}
                    price={
                      budget
                        ? orderType == config.ORDER_TYPE_REORDER
                          ? budget.maxRestock - totalReorder
                          : maxSwap
                        : 0
                    }
                    sx={{
                      fontSize: "0.8em",
                      lineHeight: "0.8em",
                      color: theme.blueText,
                    }}
                  />
                </Flex>
              </Flex>
            </Flex>
            {/* END - MOBILE TABS */}
            {/* MOBILE SEARCH & FILTERS*/}
            <FiltersAndSearchMobile
              activeFilters={allFilterValue}
              isFiltered={hasFilters || searchText}
              removeFilter={handleRemove}
              onRemoveAllFilters={handleRemoveAll}
              ref={inputSearchRef}
              onSearchSubmit={sendBtn}
              onSearchKeyUp={selectTextFilter}
              sx={{
                mx: "10px",
              }}
              {...{ removeFilter }}
              {...filterProps}
            >
              <FilterItemMobile
                name="collection"
                label={getLocalizedString("Collection filter")}
                options={collectionFilterList}
                values={collectionFilterValues}
                open={openFilterMobile}
                onSelect={selectCollectionFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="continuous"
                label={getLocalizedString("Continuous filter")}
                options={continuousFilterList}
                values={continuousFilterValues}
                open={openFilterMobile}
                onSelect={selectContinuousFilter}
                onToggleOpen={toggleFilterMobile}
              />

              <FilterItemMobile
                name="category"
                label={getLocalizedString("Category filter")}
                options={categoryFilterList}
                values={categoryFilterValues}
                open={openFilterMobile}
                onSelect={selectCategoryFilter}
                onToggleOpen={toggleFilterMobile}
              />

              <FilterItemMobile
                name="productType"
                label={getLocalizedString("Product type filter")}
                options={productTypeFilterList}
                values={productTypeFilterValues}
                open={openFilterMobile}
                onSelect={selectProductTypeFilter}
                onToggleOpen={toggleFilterMobile}
              />
              {/* COLOR FILTER */}
              <Box>
                <Flex
                  alignItems="center"
                  bg="#DEDEDE"
                  height="40px"
                  paddingX="10px"
                  style={{
                    gap: "22px",
                    borderBottom: "3px solid #D2D2D2",
                  }}
                  justifyContent="space-between"
                  onClick={() => toggleFilterMobile("color")}
                >
                  <Label fontSize="12px">
                    {getLocalizedString("Color filter")}
                  </Label>
                  <div>
                    <ChecvronDown
                      style={{
                        transform:
                          openFilterMobile === "color"
                            ? "rotate(180deg)"
                            : null,
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>
                </Flex>
                {openFilterMobile === "color" && (
                  <Flex
                    bg="#f2f2f2"
                    py="15px"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <input
                      id="colorTextFilter"
                      name="colorTextFilter"
                      placeholder="COLOR CODE"
                      style={{
                        paddingLeft: "5px",
                        height: "30px",
                        fontSize: "12px",
                        width: "93%",
                      }}
                      onKeyUp={colorTextFilter}
                    />
                  </Flex>
                )}
                <Box
                  bg="#f2f2f2"
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "calc(50% - 5px) calc(50% - 5px)",
                    gap: "10px",
                    maxHeight: "250px",
                    padding: "0 10px",
                    overflowY: "auto",
                  }}
                >
                  {openFilterMobile === "color" &&
                    colorFilterFiltered?.map((e, i) => {
                      const tmpColor = colors?.find((e1) => e1.code == e.code);
                      if (tmpColor) {
                        let textColor = selectTextColor(tmpColor.rgb);
                        return (
                          <Box
                            key={i}
                            id={"category_" + e.id}
                            data-value={e.id}
                            className="p-2"
                            style={{
                              display: "flex",
                              gap: "20px",
                              backgroundImage: `url(${e?.pantone})`,
                              backgroundSize: "150px",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center 10%",
                              height: "40px",
                              backgroundColor: tmpColor.rgb,
                              marginBottom: "2px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              alignItems: "center",
                            }}
                            onClick={(ev) => selectColorFilter(ev, e.id)}
                          >
                            <Label fontSize="12px" color={textColor}>
                              {e.code}
                            </Label>
                          </Box>
                        );
                      }
                    })}
                </Box>
              </Box>
              {/* END - COLOR FILTER */}
              {/* SIZE FILTER */}
              <Box>
                <Flex
                  alignItems="center"
                  bg="#DEDEDE"
                  height="40px"
                  paddingX="10px"
                  style={{
                    gap: "22px",
                    borderBottom: "3px solid #D2D2D2",
                  }}
                  justifyContent="space-between"
                  onClick={() => toggleFilterMobile("size")}
                >
                  <Label fontSize="12px">
                    {getLocalizedString("Size filter")}
                  </Label>
                  <div>
                    <ChecvronDown
                      style={{
                        transform:
                          openFilterMobile === "size" ? "rotate(180deg)" : null,
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>
                </Flex>
                {openFilterMobile === "size" &&
                  sizeFilterList.map((item, i) => (
                    <Flex
                      key={i}
                      height="40px"
                      bg="#f2f2f2"
                      mb="2px"
                      px="20px"
                      alignItems="center"
                      style={{ gap: "20px" }}
                    >
                      <input
                        onChange={selectSizeFilter}
                        type="checkbox"
                        id={"category_" + item.id}
                        data-value={item.id}
                        className="p-2"
                        style={{ width: "20px" }}
                        checked={sizeFilterValues?.includes(item.id)}
                      />{" "}
                      <Label fontSize="12px">
                        {getLocalizedText(item?.description)}
                      </Label>
                    </Flex>
                  ))}
              </Box>
              {/* END - SIZE FILTER */}
              <FilterItemMobile
                name="fitting"
                label={getLocalizedString("CATEGORY_FILTER_FITTING")}
                options={fittingFilterList}
                values={fittingFilterValues}
                open={openFilterMobile}
                onSelect={selectFittingFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="closure"
                label={getLocalizedString("CATALOGUE_FILTER_CLOSURE")}
                options={closureFilterList}
                values={closureFilterValues}
                open={openFilterMobile}
                onSelect={selectClosureFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="hood"
                label={getLocalizedString("CATALOGUE_FILTER_HOOD")}
                options={hoodFilterList}
                values={hoodFilterValues}
                open={openFilterMobile}
                onSelect={selectHoodFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="padding"
                label={getLocalizedString("CATALOGUE_FILTER_PADDING")}
                options={paddingFilterList}
                values={paddingFilterValues}
                open={openFilterMobile}
                onSelect={selectPaddingFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="pockets"
                label={getLocalizedString("CATALOGUE_FILTER_POCKETS")}
                options={pocketsFilterList}
                values={pocketsFilterValues}
                open={openFilterMobile}
                onSelect={selectPocketsFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="reversible"
                label={getLocalizedString("CATALOGUE_FILTER_REVERSIBLE")}
                options={reversibleFilterList}
                values={reversibleFilterValues}
                open={openFilterMobile}
                onSelect={selectReversibleFilter}
                onToggleOpen={toggleFilterMobile}
              />
              <FilterItemMobile
                name="sleeves"
                label={getLocalizedString("CATALOGUE_FILTER_SLEEVES")}
                options={sleevesFilterList}
                values={sleevesFilterValues}
                open={openFilterMobile}
                onSelect={selectSleevesFilter}
                onToggleOpen={toggleFilterMobile}
              />
            </FiltersAndSearchMobile>
            <CatalogueCount
              paddingLeft={"16px"}
              {...{ catalogue, totalCount }}
            />
            {/*END - MOBILE SEARCH & FILTERS*/}
          </Box>
        )}
        {isMobile && !!catalogueSelected && (
          <MobileProductDetail
            seasonCode={seasonCodeP}
            onClose={handleMobileDetailClose}
            type={tab == 0 ? config.ORDER_TYPE_REORDER : config.ORDER_TYPE_SWAP}
            {...{ filteredCatalogue: catalogue, catalogueSelected }}
          />
        )}
        <Flex
          width={1}
          pb={3}
          px={["10px", "10px", 4]}
          mb={"20px"}
          sx={{
            position: "relative",
            ...(isMobile &&
              disableScroll && {
                overflow: "hidden",
                height: 0,
              }),
          }}
        >
          {/** DESKTOP FILTERS */}
          <Box
            width={1 / 4}
            height={`calc(100vh - ${offsetTop + 53}px)`}
            mr={2}
            mt={"10px"}
            display={["none", "none", "block"]}
            sx={{
              position: "sticky",
              top: "63px",
              overflow: "hidden",
            }}
          >
            <Box
              className="catalogue-filters"
              width={"100%"}
              height={"100%"}
              sx={{ overflowY: "auto", paddingBottom: "40px" }}
            >
              <Box
                pb={"10px"}
                sx={{
                  position: "sticky",
                  backgroundColor: "#fff",
                  top: 0,
                  zIndex: 2,
                }}
              >
                <Box
                  p={3}
                  width={"100%"}
                  sx={{
                    position: "relative",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <SearchInput
                    ref={inputSearchRef}
                    onKeyUp={selectTextFilter}
                    onPaste={handlePasteSearch}
                    onSubmit={changeQueryClick}
                    placeholder={getLocalizedString("Search filter")}
                    sx={{ width: "100%" }}
                  />
                </Box>
              </Box>
              <FilterItem
                name="collection"
                label={getLocalizedString("Collection filter")}
                options={collectionFilterList}
                values={collectionFilterValues}
                open={openFilters}
                onSelect={selectCollectionFilter}
                onToggleOpen={toggleFilter}
              />

              <FilterItem
                name="continuous"
                label={getLocalizedString("Continuous filter")}
                options={continuousFilterList}
                values={continuousFilterValues}
                open={openFilters}
                onSelect={selectContinuousFilter}
                onToggleOpen={toggleFilter}
              />

              <FilterItem
                name="category"
                label={getLocalizedString("Category filter")}
                options={categoryFilterList}
                values={categoryFilterValues}
                open={openFilters}
                onSelect={selectCategoryFilter}
                onToggleOpen={toggleFilter}
              />

              <FilterItem
                name="productType"
                label={getLocalizedString("Product type filter")}
                options={productTypeFilterList}
                values={productTypeFilterValues}
                open={openFilters}
                onSelect={selectProductTypeFilter}
                onToggleOpen={toggleFilter}
              />
              {/* DESKTOP COLOR FILTER */}
              {colorFilterList?.length > 0 && colors?.length > 0 && (
                <Box sx={{ marginBottom: "10px" }}>
                  <Flex
                    alignItems={"center"}
                    pl={3}
                    style={{
                      fontSize: "0.8em",
                      position: "relative",
                      backgroundColor: "#EEE",
                      height: "50px",
                      borderBottom: "1px dotted #888",
                    }}
                    onClick={() => toggleFilter("color")}
                  >
                    {getLocalizedString("Color filter")}
                    <Tooltip content={getLocalizedString("ACCORDION_HIDE")}>
                      <img
                        className={
                          "absolute " +
                          (!openFilters.includes("color") ? "hidden" : "")
                        }
                        style={{ right: "15px" }}
                        src={openIcon}
                        width={20}
                        height={22}
                        alt="close icon"
                      />
                    </Tooltip>
                    <Tooltip content={getLocalizedString("ACCORDION_SHOW")}>
                      <img
                        className={
                          "absolute " +
                          (openFilters.includes("color") ? "hidden" : "")
                        }
                        style={{ right: "15px" }}
                        src={closeIcon}
                        width={20}
                        height={22}
                        alt="open icon"
                      />
                    </Tooltip>
                  </Flex>
                  <Flex
                    w={1}
                    p={3}
                    style={{
                      backgroundColor: "#EEE",
                      position: "relative",
                      visibility: !openFilters.includes("color")
                        ? "hidden"
                        : "",
                      display: !openFilters.includes("color") ? "none" : "",
                    }}
                  >
                    <Input
                      id="colorTextFilter"
                      name="colorTextFilter"
                      type="text"
                      placeholder="COLOR CODE"
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        fontSize: "0.8em",
                      }}
                      onKeyUp={colorTextFilter}
                    />
                  </Flex>
                  <Flex
                    w={1}
                    p={3}
                    style={{
                      backgroundColor: "#EEE",
                      position: "relative",
                      visibility: !openFilters.includes("color")
                        ? "hidden"
                        : "",
                      display: !openFilters.includes("color") ? "none" : "",
                    }}
                  >
                    <Flex
                      style={{
                        width: "100%",
                        maxHeight: "250px",
                        overflowY: isChrome ? "overlay" : "scroll",
                      }}
                      flexDirection={"row"}
                      flexWrap={"wrap"}
                    >
                      {colorFilterFiltered?.map((e, i) => {
                        const tmpColor = colors?.find(
                          (e1) => e1.code == e.code,
                        );
                        if (tmpColor) {
                          let textColor = selectTextColor(tmpColor.rgb);
                          return (
                            <Flex
                              key={i}
                              onClick={selectColorFilter}
                              alignItems="center"
                              justifyContent={"center"}
                              p={2}
                              mr={2}
                              mb={2}
                              data-value={e.id}
                              data-selected={false}
                              id={"color_" + e.id}
                              style={{
                                textAlign: "center",
                                color: textColor,
                                backgroundColor: tmpColor.rgb,
                                backgroundSize: "150px",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center 10%",
                                height: "30px",
                                width: "57px",
                                border:
                                  "0px solid " +
                                  (colorFilterValues?.includes(e.id)
                                    ? "red"
                                    : "black"),
                                cursor: "pointer",
                                backgroundImage: `url(${e.pantone})`,
                                fontSize: "14px",
                              }}
                            >
                              {e.code}
                            </Flex>
                          );
                        }
                      })}
                      {colorFilterFiltered?.length === 0 && (
                        <Box p={2} m={1} style={{ fontSize: "10px" }}>
                          {getLocalizedString(
                            "CODE_COLOR_NOT_FOUND",
                          ).toUpperCase()}
                        </Box>
                      )}
                    </Flex>
                  </Flex>
                </Box>
              )}
              {/* END - DESKTOP COLOR FILTER */}
              {/* DESKTOP SIZE FILTER */}
              <Box
                sx={{
                  marginBottom: "10px",
                }}
              >
                <Flex
                  alignItems={"center"}
                  pl={3}
                  style={{
                    fontSize: "0.8em",
                    position: "relative",
                    backgroundColor: "#EEE",
                    height: "50px",
                    borderBottom: "1px dotted #888",
                  }}
                  onClick={() => toggleFilter("size")}
                >
                  {getLocalizedString("Size filter")}
                  <Tooltip content={getLocalizedString("ACCORDION_HIDE")}>
                    <img
                      alt=""
                      className={
                        "absolute " +
                        (!openFilters.includes("size") ? "hidden" : "")
                      }
                      style={{ right: "15px" }}
                      src={openIcon}
                      width={20}
                      height={22}
                    />
                  </Tooltip>
                  <Tooltip content={getLocalizedString("ACCORDION_SHOW")}>
                    <img
                      alt=""
                      className={
                        "absolute " +
                        (openFilters.includes("size") ? "hidden" : "")
                      }
                      style={{ right: "15px" }}
                      src={closeIcon}
                      width={20}
                      height={22}
                    />
                  </Tooltip>
                </Flex>

                <Flex
                  w={1}
                  p={3}
                  className={"w-full p-5 "}
                  style={{
                    backgroundColor: "#EEE",
                    position: "relative",
                    visibility: !openFilters.includes("size") ? "hidden" : "",
                    display: !openFilters.includes("size") ? "none" : "",
                  }}
                >
                  {!!sizeFilterList?.length && (
                    <Box
                      width={1}
                      sx={{
                        display: "grid",
                        gridGap: 2,
                        gridTemplateColumns: "repeat(auto-fill, 65px)",
                      }}
                    >
                      {sizeFilterList
                        .sort((a, b) => {
                          a = a.code;
                          b = b.code;

                          a = a.replace("½", ".5");
                          a = a.replace("A", "");

                          b = b.replace("½", ".5");
                          b = b.replace("A", "");

                          a = Number(a) || 2;
                          b = Number(b) || 1;

                          return a - b;
                        })
                        .map((e, i) => (
                          <Flex
                            key={i}
                            alignItems="center"
                            justifyContent={"center"}
                            onClick={selectSizeFilter}
                            p={2}
                            data-value={e.id}
                            data-selected={false}
                            id={"size_" + e.id}
                            style={{
                              width: 65,
                              height: 30,
                              fontSize: "0.8em",
                              textAlign: "center",
                              border:
                                "1px solid " +
                                (sizeFilterValues?.includes(e.id)
                                  ? "red"
                                  : "black"),
                            }}
                          >
                            {getLocalizedText(e.description)}
                          </Flex>
                        ))}
                    </Box>
                  )}
                  {(!sizeFilterList || sizeFilterList?.length === 0) && (
                    <Box p={2} m={1} style={{ fontSize: "10px" }}>
                      {getLocalizedString("Selezionare almeno una categoria")}
                    </Box>
                  )}
                </Flex>
              </Box>
              {/* END - DESKTOP SIZE FILTER */}
              <FilterItem
                name="fitting"
                label={getLocalizedString("CATEGORY_FILTER_FITTING")}
                options={fittingFilterList}
                values={fittingFilterValues}
                open={openFilters}
                onSelect={selectFittingFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="closure"
                label={getLocalizedString("CATALOGUE_FILTER_CLOSURE")}
                options={closureFilterList}
                values={closureFilterValues}
                open={openFilters}
                onSelect={selectClosureFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="hood"
                label={getLocalizedString("CATALOGUE_FILTER_HOOD")}
                options={hoodFilterList}
                values={hoodFilterValues}
                open={openFilters}
                onSelect={selectHoodFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="padding"
                label={getLocalizedString("CATALOGUE_FILTER_PADDING")}
                options={paddingFilterList}
                values={paddingFilterValues}
                open={openFilters}
                onSelect={selectPaddingFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="pockets"
                label={getLocalizedString("CATALOGUE_FILTER_POCKETS")}
                options={pocketsFilterList}
                values={pocketsFilterValues}
                open={openFilters}
                onSelect={selectPocketsFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="closure"
                label={getLocalizedString("CATALOGUE_FILTER_REVERSIBLE")}
                options={reversibleFilterList}
                values={reversibleFilterValues}
                open={openFilters}
                onSelect={selectReversibleFilter}
                onToggleOpen={toggleFilter}
              />
              <FilterItem
                name="closure"
                label={getLocalizedString("CATALOGUE_FILTER_SLEEVES")}
                options={sleevesFilterList}
                values={sleevesFilterValues}
                open={openFilters}
                onSelect={selectSleevesFilter}
                onToggleOpen={toggleFilter}
              />
            </Box>
          </Box>
          {/** END - DESKTOP FILTERS */}

          <Flex
            width={[1, 1, 3 / 4]}
            height={"auto"}
            paddingTop={isMobile ? 3 : 0}
            sx={{ flexDirection: "column" }}
          >
            {/** DESKTOP FILTER CHIPS */}
            <Box
              height={"auto"}
              width={"100%"}
              alignSelf={"center"}
              pt={"10px"}
              pb={"10px"}
              display={["none", "none", "block"]}
              sx={{
                position: "sticky",
                top: "53px",
                backgroundColor: "#fff",
                zIndex: 2,
              }}
            >
              <Flex w={1} flexDirection={"column"} minHeight={"72px"}>
                <Flex
                  w={1}
                  flexDirection={"row"}
                  alignItems={"flex-start"}
                  p={1}
                  sx={{
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <Flex
                    style={{ width: "calc(100% - 150px)" }}
                    flexDirection={"row"}
                    flexWrap={"wrap"}
                    sx={{
                      gap: "5px",
                    }}
                  >
                    {!!allFilterValue?.length &&
                      allFilterValue?.map((filter, index) => {
                        const { value, text } = filter || {};
                        if (!value || !text) return null;
                        return (
                          <Chip
                            key={`mobile-filter-chips-${index}`}
                            text={getLocalizedText(text)}
                            remove={() => handleRemove(value)}
                          />
                        );
                      })}
                    {allFilterValue?.length == 0 && (
                      <Box p={2} m={1} style={{ fontSize: "10px" }}>
                        {getLocalizedString("No filter")}
                      </Box>
                    )}
                  </Flex>
                  <Box style={{ width: "150px" }}>
                    {allFilterValue?.length > 0 && (
                      <Box
                        onClick={handleRemoveAll}
                        pl={3}
                        pr={3}
                        pt={2}
                        pb={2}
                        m={1}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          position: "relative",
                          fontSize: "10px",
                          backgroundColor: "#545454",
                          color: "white",
                          borderRadius: "5px",
                        }}
                      >
                        {getLocalizedString("Remove all filter")}
                      </Box>
                    )}
                  </Box>
                </Flex>
                <CatalogueCount {...{ catalogue, totalCount }} />
              </Flex>
            </Box>
            {/** END - DESKTOP FILTER CHIPS */}
            {/** CATALOGUE */}
            {catalogue?.length === 0 && (
              <Flex
                style={{
                  height: "150px",
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  marginLeft: "30px",
                }}
                justifyContent={"center"}
                mb={4}
                fontSize={12}
              >
                {getLocalizedString("CATALOGUE IS EMPTY")}
              </Flex>
            )}

            <Box
              id="gridContainer"
              sx={{
                display: "grid",
                gridGap: ["10px", null, 3],
                gridTemplateColumns: [
                  "repeat(2, 1fr)",
                  "repeat(3, 1fr)",
                  "repeat(3, 1fr)",
                ],
                justifyContent: "center",
                transition: "300ms",
                position: "relative",
                alignItems: "baseline",
              }}
              // onWheel={scrollHandle}
            >
              {catalogue?.length > 0 &&
                reorderCatalogue(catalogue).map((item, index) => {
                  const expanded = catalogueSelected == item.productId;
                  return (
                    <Box
                      key={`catalogue-item-${index}-${item.productId}`}
                      ref={(el) => (catalogueRefs.current[item.productId] = el)}
                      {...(!isMobile &&
                        expanded && {
                          sx: { gridColumn: "1 / -1" },
                        })}
                    >
                      {tab == 0 && (
                        <Product
                          id={item.productId}
                          images={item.catalog}
                          swap={false}
                          catalog={item?.catalog}
                          seasonCode={seasonCodeP}
                          modelCode={item.modelCode}
                          articleCode={item.materialCode}
                          colorCodes={item.color}
                          lineCode={item.lineCode}
                          collectionCode={item.collectionCode}
                          collectionDescription={item.collectionDescription}
                          seasonDescription={item.seasonDescription}
                          modelDescription={item.modelDescription}
                          materialCode={item.materialCode}
                          materialDescription={item.materialDescription}
                          materialComposition={item.materialComposition}
                          categoryCode={item.categoryCode}
                          categoryDescription={item.categoryDescription}
                          subcategoryCode={item.subcategoryCode}
                          subcategoryDescription={item.subcategoryDescription}
                          sizes={item.sizes}
                          color={item.color}
                          shape={item.shape}
                          padding={item.padding}
                          fit={item.fit}
                          tag={item.tag}
                          sleevs={item.sleevs}
                          closure={item.closure}
                          hood={item.hood}
                          pockets={item.pockets}
                          sku={item.sku}
                          madeIn={item.madeIn}
                          prices={item.price}
                          continuous={item.continuous}
                          reversible={item.reversible}
                          imagedefault={item.imagedefault}
                          rotationdefault={item.rotationdefault}
                          checkForNext={
                            index == catalogue.length - 1 ? true : false
                          }
                          {...(!isMobile && { expanded })}
                        />
                      )}
                      {tab == 1 && (
                        <ProductSwap
                          id={item.productId}
                          swap={true}
                          images={item.catalog}
                          catalog={item?.catalog}
                          seasonCode={seasonCodeP}
                          modelCode={item.modelCode}
                          articleCode={item.materialCode}
                          colorCodes={item.color}
                          lineCode={item.lineCode}
                          collectionCode={item.collectionCode}
                          collectionDescription={item.collectionDescription}
                          seasonDescription={item.seasonDescription}
                          modelDescription={item.modelDescription}
                          materialCode={item.materialCode}
                          materialDescription={item.materialDescription}
                          materialComposition={item.materialComposition}
                          categoryCode={item.categoryCode}
                          categoryDescription={item.categoryDescription}
                          subcategoryCode={item.subcategoryCode}
                          subcategoryDescription={item.subcategoryDescription}
                          sizes={item.sizes}
                          color={item.color}
                          shape={item.shape}
                          padding={item.padding}
                          fit={item.fit}
                          tag={item.tag}
                          sleevs={item.sleevs}
                          closure={item.closure}
                          hood={item.hood}
                          pockets={item.pockets}
                          sku={item.sku}
                          madeIn={item.madeIn}
                          prices={item.price}
                          rotationdefault={item.rotationdefault}
                          {...(!isMobile && {
                            expanded: catalogueSelected == item.productId,
                          })}
                          imagedefault={item.imagedefault}
                          checkForNext={
                            index == catalogue.length - 1 ? true : false
                          }
                        />
                      )}
                    </Box>
                  );
                })}
            </Box>
            <CatalogueNavigation
              sx={{ marginTop: "20px" }}
              onLoadMore={() => setCatalogueRequestNext(true)}
              onGoToTop={resetScroll}
              {...{ catalogue, currentPage, totalPages, nextPageInLoading }}
            />
            {/** END - CATALOGUE */}
          </Flex>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export { CataloguePage };
